module.exports = __webpack_public_path__ + "static/media/score_result_2.81444edd.png";